import React from 'react';
const Section = ({ field, fieldFactory, }) => React.createElement("fieldset", { className: field.model.cssClass }, field.fields.map(fieldFactory));
export default Section;
